/** Strips non-digits; caps at 11. */
export function normalizeCpfDigits(input: string): string {
    return input.replace(/\D/g, "").slice(0, 11);
}

export function formatCpfDisplay(digits: string): string {

    if (digits?.length < 1 || typeof digits !== "string") {
        return "";
    }

    const d = normalizeCpfDigits(digits);
    if (d.length <= 3) {
return d;
}
    if (d.length <= 6) {
return `${d.slice(0, 3)}.${d.slice(3)}`;
}
    if (d.length <= 9) {
return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
}
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

export function isValidCpf(input: string): boolean {
    const cpf = normalizeCpfDigits(input);
    if (cpf.length !== 11) {
return false;
}
    if (/^(\d)\1{10}$/.test(cpf)) {
return false;
}

    const digits = cpf.split("").map(Number);
    let sum = 0;
    for (let i = 0; i < 9; i++) {
sum += digits[i] * (10 - i);
}
    let d1 = sum % 11;
    d1 = d1 < 2 ? 0 : 11 - d1;
    if (digits[9] !== d1) {
return false;
}

    sum = 0;
    for (let i = 0; i < 10; i++) {
sum += digits[i] * (11 - i);
}
    let d2 = sum % 11;
    d2 = d2 < 2 ? 0 : 11 - d2;
    return digits[10] === d2;
}
